import { Injectable } from '@angular/core';
import { AbstractLoggerService} from 'angular-auth-oidc-client';

@Injectable()
export class OidcLoggerService implements AbstractLoggerService {
  logError(message: any): void {
    console.error(message);
  }
  logWarning(message: any): void {
    console.warn(message);
  }
  logDebug(message: any): void {
    console.log(message);
  }
}